import { SET_PLASTIC_BAG_CONSENT } from './../constants/apis.constants';
import {
  EApiMiddlewareMethods,
  TApiMiddlewareDispatch,
} from 'config/redux/middlewares/api.middleware.types';
import { EPlasticBagActions } from '../orderData.type';

export const setPlasticBagUserConsent = (flag: any) => async (dispatch: TApiMiddlewareDispatch) => {
  await dispatch({
    type: EPlasticBagActions.SET_USER_CONSENT,
    payload: {
      url: SET_PLASTIC_BAG_CONSENT,
      isAbsUrl: true,
      method: EApiMiddlewareMethods.PATCH,
      data: {
        singleUseBagOpted: flag,
      },
    },
  });
};
